<template>
  <div class="app-container">
    <header-bar></header-bar>
    <div class="content-wrapper">
      <div class="empty-left"></div>
      <div class="left-sidenotes"></div>
      <div class="main">
        <p class="header">AI Policy</p>
        <p>Ansable VT utilizes artificial intelligence (AI) as a tool, not a final solution. Our goal is to provide easy access to your local government by tackling reporting and information deserts in small communities. Over the last 30 years, this type of coverage has been decreasing and a new approach is required.</p>
        <p>But like any tool, AI requires checks and balances (and a good editor). It's not a silver bullet. Ansable VT utilizes machine learning and an array of large language models to create transcripts and summaries for local meetings and news stories. We take town-produced meeting agendas, minutes and audio files and feed them into our system (our own AI magic of sorts) which results in a key points summary of the meeting that reads like a news article. We then edit these summaries to correct any major errors.</p>
        <p>How do we get high quality output? It’s a trade secret, but in short we reinforce the model by having an editor (with a decade of experience working in local news) write her own summaries of different meetings. Using these write ups, the model learns how to approach a meeting and relay the important information clearly.</p>
        <p>For the news summaries, we used a similar process. Brief, editor-written summaries of news stories from sources around the state were used to teach the model how to best capture info in a way that makes readers want to click in and visit the full story on the publication’s own site.</p>
        <p>Please note that while we do our best to ensure all information is fair and accurate, AI summaries, like the dedicated individuals who write the meeting agendas and minutes, sometimes make mistakes. When these are brought to our attention, we’ll correct them as soon as possible.</p>
      </div>
      <div class="right-sidenotes"></div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import HeaderBar from "./RevisedHeader.vue";
import FooterBar from "./FooterBar.vue";

export default {
  name: "AboutUs",
  components: {
    HeaderBar,
    FooterBar,
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

.app-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.content-wrapper {
  position: relative;
  flex: 1;
  display: flex;
  overflow: hidden;
  background-color: #fffff8;
  padding-top: 64px;
}

.empty-left {
  flex: 1;
  background-color: #fffff8;
}

.left-sidenotes,
.right-sidenotes {
  flex: 1;
  background-color: #fffff8;
}

.main {
  flex: 3;
  background-color: #fffff8;
  display: flex;
  flex-direction: column;
  overflow: auto;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.header {
  font-weight: bold;
  margin-bottom: 0rem;
  margin-top: 2rem;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 1rem;
}

/* Footer styling */
footer-bar {
  display: block;
  width: 100%;
  background-color: #545051;
  color: white;
  padding: 16px;
  text-align: center;
  font-size: 0.9rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .empty-left,
  .left-sidenotes,
  .right-sidenotes {
    display: none;
  }
  .main {
    flex: 1;
    max-width: 100%;
    padding: 0 1rem;
  }
}

@media (min-width: 1024px) {
  .empty-left,
  .left-sidenotes,
  .right-sidenotes {
    display: flex;
  }
  .main {
    flex: 3;
    max-width: 1200px;
    padding: 0;
  }
}
</style>
